<template>
  <b-modal id="passport-det" ref="modal" size="lg" title="Detail" @show="setModal" @hidden="resetModal" >
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Passport Type</label>
                <div class="col-md-8 mb-3">
                  {{detail.type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country </label>
                <div class="col-md-8 mb-3">
                  {{detail.country_code}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.passport_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.passport_number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nationality </label>
                <div class="col-md-8 mb-3">
                  {{detail.nationality_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Birth Place</label>
                <div class="col-md-8 mb-3">
                  {{detail.place_of_birth}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Birth Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.date_of_birth}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Issue Office</label>
                <div class="col-md-8 mb-3">
                  {{detail.issuing_office}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Issuing Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.date_of_issue}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.date_of_expired}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{ (detail.status === 1 ? 'Active':'Not Active')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal()"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
export default {
  name: "PassportDetail",
  components:{
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{
        type_name:"",
        country_code:"",
        passport_name:"",
        passport_number:"",
        nationality_name:"",
        place_of_birth:"",
        date_of_birth:"",
        issuing_office:"",
        date_of_issue:"",
        date_of_expired:"",
        desc:"",
        status:""
      }
    }
  },
  methods:{
    resetModal(){
      this.$parent.data = null
      this.$refs.modal.hide()
    },
    setModal(){
      setTimeout(()=>{
        if(this.data !== null){
          this.detail.type_name = this.data.type_name
          this.detail.country_code = this.data.country_code
          this.detail.passport_name = this.data.passport_name
          this.detail.passport_number = this.data.passport_number
          this.detail.nationality_name = this.data.nationality_name
          this.detail.place_of_birth = this.data.place_of_birth
          this.detail.date_of_birth = this.data.date_of_birth
          this.detail.issuing_office = this.data.issuing_office
          this.detail.date_of_issue = this.data.date_of_issue
          this.detail.date_of_expired = this.data.date_of_expired
          this.detail.desc = this.data.desc
          this.detail.status = this.data.status
        }
      }, 100)
    }
  }
}
</script>